import { useAtom } from 'jotai';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { SettingsDrawerControl } from '../../session';
import { VisitorDrawerState, visitorDrawerStateAtom } from '../state';
import { VisitorSettingsDrawerControlMenuItem } from './VisitorSettingsDrawerControls';
import type { VisitorSettingsDrawerMenuItemProps } from './VisitorSettingsDrawerControls';

export function VisitorSettingsDrawerControlMenuItemWrapper(
  props: Pick<VisitorSettingsDrawerMenuItemProps, 'drawerId'>,
) {
  const { isSettingsDrawerOpen, toggleDrawerState } = useVisitorDrawerControls();
  return (
    <VisitorSettingsDrawerControlMenuItem
      drawerId={props.drawerId}
      isSettingsDrawerOpen={isSettingsDrawerOpen}
      onClick={toggleDrawerState}
    />
  );
}

export function VisitorSettingsDrawerButton(props: Pick<VisitorSettingsDrawerMenuItemProps, 'drawerId'>) {
  const { isSettingsDrawerOpen, toggleDrawerState } = useVisitorDrawerControls();
  return (
    <SettingsDrawerControl
      forDrawerStates={VisitorDrawerState.SETTINGS}
      isSettingsDrawerOpen={isSettingsDrawerOpen}
      onClick={toggleDrawerState}
      drawerId={props.drawerId}
    />
  );
}

function useVisitorDrawerControls() {
  const [drawerState, setDrawerState] = useAtom(visitorDrawerStateAtom);
  const isSettingsDrawerOpen = drawerState === VisitorDrawerState.SETTINGS;
  const getDrawerState = useAtomCallbackMemoized((get) => get(visitorDrawerStateAtom), []);
  const toggleDrawerState = () => {
    const currentDrawerState = getDrawerState();
    if (currentDrawerState === VisitorDrawerState.SETTINGS) {
      setDrawerState(null);
      return;
    }
    setDrawerState(VisitorDrawerState.SETTINGS);
  };

  return {
    isSettingsDrawerOpen,
    toggleDrawerState,
  };
}
